import { Injectable } from '@angular/core';
import { SyncApiService } from '../../../shared/services/sync-api.service';
import { CurrentUserService } from '../../../user/current-user.service';
import { IMusimapFilterPrototype, IMusimapPreferencePrototype } from '../musimap-common/musimap-common.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MUSIMAP_API, MUSIMAP_DIVISIONS, MUSIMAP_FILTERS, MUSIMAP_PROPS } from '../musimap-common/musimap-common.enum';
import { isArray } from '../../../abstract';
import {
  getDefaultDivisionSelections,
  getDefaultPreferences,
  getExtendedDivisionSelections,
  getPreferencesQueryTemplate,
} from '../musimap-common/musimap-defaults.lib';
import { EUserDivision } from '../../../user/user.model';

@Injectable()
export class MusimapApiService {
  constructor(private api: SyncApiService, private userService: CurrentUserService) {}

  public loadMusimapFilters = (): Observable<IMusimapFilterPrototype[]> =>
    this.api.get(MUSIMAP_API.EXTENDED_FILTERS).pipe(
      map((filters: any[]) => {
        const rating = filters?.find(f => f.label === MUSIMAP_FILTERS.RATING);
        const recordLabel = filters?.find(f => f.label === MUSIMAP_FILTERS.RECORD_LABEL);

        rating && (rating.values = rating.values.filter(v => v));
        recordLabel && (recordLabel.values = recordLabel.values.filter(v => v));

        return filters;
      })
    );

  public loadGlsFilters = (): Observable<IMusimapFilterPrototype[]> => this.api.get(MUSIMAP_API.FILTERS);

  get userDivision(): EUserDivision {
    return this.userService.currentUserInfo$?.value?.division;
  }
  public loadDivisions = (): Observable<string[]> =>
    (this.userService.currentUserInfo$.value
      ? this.userService.currentUserInfo$.asObservable()
      : this.userService.getCurrentUserInfo()
    ).pipe(
      map(user => user.division),
      map(division => getDefaultDivisionSelections()[division])
    );

  public loadExtendedDivisions = (): Observable<MUSIMAP_DIVISIONS[]> =>
    (this.userService.currentUserInfo$.value
      ? this.userService.currentUserInfo$.asObservable()
      : this.userService.getCurrentUserInfo()
    ).pipe(
      map(user => user.division),
      map(division => getExtendedDivisionSelections()[division])
    );

  public loadPreferences = (): Observable<IMusimapPreferencePrototype[]> =>
    this.api.get(MUSIMAP_API.SAVED_PREFERENCES).pipe(
      map(result => JSON.parse(result[MUSIMAP_PROPS.SEARCH_FILTER_SETTINGS])?.filters || []),
      map(filters => (isArray(filters) ? filters : this.clearPreferences()))
    );

  public savePreferences = (preferences: IMusimapPreferencePrototype[]): Observable<IMusimapPreferencePrototype[]> => {
    const preferencesQueryTemplate = getPreferencesQueryTemplate();

    return this.api
      .post(MUSIMAP_API.SAVED_PREFERENCES, {
        ...preferencesQueryTemplate,
        [MUSIMAP_PROPS.SEARCH_FILTER_SETTINGS]: JSON.stringify({
          filters: preferences,
        }),
      })
      .pipe(map(() => preferences));
  };

  public clearPreferences = (): Observable<IMusimapPreferencePrototype[]> =>
    this.api.post(MUSIMAP_API.SAVED_PREFERENCES, getDefaultPreferences()).pipe(map(() => []));
}
